import { IHttpApi } from '@cian/http-api/shared';
import { EPaymentProvider } from '../../../../PaymentWidgetMicrofrontend';

export enum EPaymentStatus {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Canceled = 'canceled',
}

export interface IPaymentStatus {
  /** Статус платежа */
  status: EPaymentStatus;
  /** Поясняющий текст */
  message: string | null;
}

export interface IGetPaymentStatusDependencies {
  httpApi: IHttpApi;
  paymentId: string;
  provider: EPaymentProvider;
}
